import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { configMainMenu } from './config/top-menu.config';
import { SalesAppService } from './services/sales-app.service';
import { AdminUserService } from './admin/user/user.service';
import { ChatHelpDeskComponent } from '../../../evolutics-shared-lib/src/lib/Shared/components/page-icons/chat-help-desk/chat-help-desk.component';
import { LoaderComponent } from 'ets-fe-ng-sdk';
import { MatProgressBar } from '@angular/material/progress-bar';
import { SharedAppComponent } from 'projects/evolutics-shared-lib/src/lib/shared-app.component';
import { UserPreviewModalComponent } from '@Shared/components/user-preview-modal/user-preview-modal.component';
import { ToastNotificationsComponent } from '@serene-dev/toast-notifications';
import { UserHelperComponent } from '../../../evolutics-shared-lib/src/lib/Shared/components/page-icons/user-helper/user-helper.component';

//import { configForms } from 'ets-fe-ng-sdk';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    MatProgressBar,
    LoaderComponent,
    RouterOutlet,
    UserPreviewModalComponent,
    ToastNotificationsComponent,
    UserHelperComponent,
  ],
})
export class AppComponent extends SharedAppComponent {
  constructor(
    private sappS: SalesAppService,
    adminUserService: AdminUserService,
  ) {
    super();
    this.searchS.buildIndex();
    // environment.versionNo = 'v1.0.0';
    environment.isSalesPortal = true;
    environment.webUserSignal.set(sappS.webUser);
    environment.useUserMenu = true;
    this.appS.topMenu = configMainMenu;
  }
  async ngOnInit() {
    super.ngOnInit();
    if (this.authService.isLoggedinToSalesPortal) {
      this.authService.getAllFromLocal(true);
    }
  }
  ngAfterViewInit() {
    return super.ngAfterViewInit();
  }
}
